import * as React from 'react';
import { useContext } from 'react';
import { StoreContext } from '../../../services/store';
import { IMedia } from '../../../types';
import ModalCarousel from './ModalCarousel';
import ProductListCarousel from './ProductListCarousel';

interface Props<T> {
  items: T[];
  style?: React.CSSProperties;
  onPostChange: (post: IMedia | null) => void;
}

// Maximum number of visible elements for mobile carousels
const MAX_MOBILE_CAROUSEL_ELEMS = 3;

const Carousel = (props: Props<JSX.Element>) => {
  const {
    data: { settings },
    isMobile,
  } = useContext(StoreContext);

  // Default mobile count is 1 but can be overridden in settings (capped below)
  const mobileCarouselNbElems = settings.mobile_carousel_content_size || 1;
  const nbElems = isMobile
    ? Math.min(mobileCarouselNbElems, MAX_MOBILE_CAROUSEL_ELEMS)
    : settings.content_size;

  const showProductListCarousel = !isMobile && settings.shop_this_look_display === 'product_list';

  if (showProductListCarousel) {
    return (
      <ProductListCarousel
        {...props}
        contentSize={nbElems}
      />
    );
  }

  return (
    <ModalCarousel
      {...props}
      nbElems={nbElems}
    />
  );
};

export default Carousel;
